import React from "react";
import { BookOpenIcon } from "lucide-react";
import { Accordion } from "./Accordion";
import { TOMOS } from "../data/tomos";
export function Tomos() {
  return <section className="w-full bg-beige px-5 py-10" data-id="element-169" data-mp="139uykibumd9o">
      <div className="mx-auto max-w-md" data-id="element-170" data-mp="1h3w1lo9u2mfu">
        <div className="mb-6 flex flex-col items-center text-center" data-id="element-171" data-mp="1h4xelyaetj07">
          <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-italian-green px-3 py-1 text-xs font-semibold text-cream" data-id="element-172" data-mp="1cat79dx8f8yl">
            <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="1m25wdxrnbl0x" /> 6 Tomos paso
            a paso
          </span>
          <h2 className="font-serif text-2xl font-bold text-deep-green" data-id="element-174" data-mp="202gp76cin9oq">
            Un sistema claro de 6 tomos
          </h2>
          <p className="mt-2 text-sm text-ink/70" data-id="element-175" data-mp="1w1ofkbzqf2rx">
            Tocá cada tomo para ver todo lo que aprenderás dentro.
          </p>
        </div>

        <Accordion items={TOMOS} variant="green" data-id="element-176" data-mp="5pqrsemxvicl" />
      </div>
    </section>;
}